<template>
  <span>
    <span class="mr-1">{{ text }}</span>
    <el-popover
      :placement="placement"
      :width="width"
      trigger="click"
      @hide="onContentHide"
      ref="popover"
    >
      <div class="filter-content">
        <el-input
          autosize
          :size="size"
          :placeholder="placeholder"
          v-model="keyword"
          clearable
        >
        </el-input>
        <el-card shadow="never" class="mt-1 mb-1">
          <ul :style="{ height: `${height || 350}px` }" v-if="!isEmptyData">
            <li>
              <el-checkbox
                :label="'全选'"
                :indeterminate="isIndeterminate"
                v-model="allChecked"
                @change="handleAllCheckChange"
              >
              </el-checkbox>
            </li>
            <el-checkbox-group
              v-model="checkedItem"
              :size="size"
              @change="handleCheckedItemChange"
            >
              <li v-for="item in data" :key="item">
                <el-checkbox :label="item">
                  {{ item }}
                </el-checkbox>
              </li>
            </el-checkbox-group>
          </ul>
          <div
            class="checkbox-empty"
            :style="{ height: `${height || 350}px` }"
            v-if="isEmptyData"
          >
            <el-empty></el-empty>
          </div>
        </el-card>
        <div class="button-group">
          <el-button
            :size="size"
            type="primary"
            @click="filter()"
            :disabled="!isChecked"
          >
            筛选
          </el-button>
          <el-button :size="size" @click="reset()">重置</el-button>
        </div>
      </div>
      <span slot="reference">
        <i
          :class="[icon, isChecked && !allChecked ? 'has-checked-icon' : '']"
        ></i>
      </span>
    </el-popover>
  </span>
</template>

<script>
export default {
  props: {
    text: { type: String, default: '' },
    size: { type: String, default: 'mini' },
    placeholder: {
      type: String,
      default: '（支持多条件过滤，例如：01XXXXX,02XXXXX）',
    },
    items: { type: Array, default: () => [] },
    icon: { type: String, default: 'vxe-icon--funnel' },
    placement: { type: String, default: 'bottom' },
    height: { type: Number, default: 350 },
    width: { type: Number, default: 300 },
    submitFilterOnClose: { type: Boolean, default: false },
  },
  data() {
    return {
      data: [],
      keyword: '',
      checkedItem: [],
      oldCheckedItem: [],
      visible: false,
      allChecked: true,
      isIndeterminate: false,
    }
  },
  computed: {
    isChecked() {
      return this.checkedItem && this.checkedItem.length
    },
    isEmptyData() {
      return !this.data || !this.data.length
    },
  },
  watch: {
    items: {
      handler() {
        this.filterData()
        this.oldCheckedItem = this.items
      },
      deep: true,
      immediate: true,
    },
    keyword() {
      this.filterData()
    },
  },
  methods: {
    filterData() {
      const items = this.items || []
      const strs = this.keyword.split(',').filter(Boolean)
      if (!strs || !strs.length) {
        this.data = items
      } else {
        this.data = items.filter(
          (i) => strs.findIndex((j) => !!i.match(`^${j}`)) >= 0
        )
      }

      this.checkedItem = this.data
      this.allChecked = true
      this.isIndeterminate = false
    },
    handleAllCheckChange(e) {
      this.checkedItem = e ? this.data : []
      this.isIndeterminate = false
    },
    handleCheckedItemChange(e) {
      const checkedCount = e.length
      this.allChecked = checkedCount === this.data.length
      this.isIndeterminate = !!checkedCount && checkedCount < this.data.length
    },
    reset() {
      this.keyword = ''
      this.data = this.items
      this.checkedItem = this.data
      this.isIndeterminate = false
      this.allChecked = true
      this.filter()
    },
    filter() {
      this.oldCheckedItem = this.checkedItem
      this.$emit('filter', this.checkedItem)

      if (this.submitFilterOnClose) this.$refs.popover.doClose()
    },
    onContentHide() {
      this.keyword = ''
      const oldData = this.oldCheckedItem
      setTimeout(() => {
        this.checkedItem = oldData
        this.oldCheckedItem = oldData
        const checkedCount = this.checkedItem.length
        this.allChecked = checkedCount === this.data.length
        this.isIndeterminate = !!checkedCount && checkedCount < this.data.length
      }, 0)
      this.$emit('hide')
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  overflow: auto;
  li {
    margin: 4px 0;
  }
}

::v-deep .el-divider {
  margin: 5px 0;
}
::v-deep .el-empty {
  padding: 10px 0;
}
::v-deep .el-empty__description {
  display: none;
}
::v-deep .el-card__body {
  padding: 0 10px;
}
::v-deep .el-input__inner {
  padding: 0 5px;
}

.button-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.has-checked-icon {
  color: #409eff !important;
}

.checkbox-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
